import { facadeFactory, GeoPoint, PointOfService, SearchConfig } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { STORE_FINDER_FEATURE } from '@spartacus/storefinder/root';
import { Observable } from 'rxjs';

export function storeFinderFacadeFactory() {
  return facadeFactory({
    facade: StoreFinderFacade,
    feature: STORE_FINDER_FEATURE,
    methods: [
      'getStoresLoading',
      'getStoresLoaded',
      'getFindStoresEntities',
      'getFindStoreEntityById',
      'getViewAllStoresLoading',
      'getViewAllStoresEntities',
      'findStoresAction',
      'viewAllStores',
      'viewStoreById',
      'callFindStoresAction',
      'getStoreLatitude',
      'getStoreLongitude'
    ],
    async: true
  });
}

@Injectable({
  providedIn: 'root',
  useFactory: storeFinderFacadeFactory
})
export abstract class StoreFinderFacade {
  abstract getStoresLoading(): Observable<boolean>;

  abstract getStoresLoaded(): Observable<boolean>;

  abstract getFindStoresEntities(): Observable<any>;

  abstract getFindStoreEntityById(): Observable<any>;

  abstract getViewAllStoresLoading(): Observable<boolean>;

  abstract getViewAllStoresEntities(): Observable<any>;

  abstract findStoresAction(
    queryText: string,
    searchConfig?: SearchConfig,
    longitudeLatitude?: GeoPoint,
    countryIsoCode?: string,
    useMyLocation?: boolean,
    radius?: number
  ): void;

  abstract viewAllStores(): void;

  abstract viewStoreById(storeId: string): void;

  abstract callFindStoresAction(routeParams: { [key: string]: string }): void;

  abstract getStoreLatitude(location: PointOfService): Observable<number | undefined>;

  abstract getStoreLongitude(location: PointOfService): Observable<number | undefined>;
}
